import { Component } from '@angular/core';
import { AuthenticationService, UserRole } from '@app/core/authentication/authentication.service';
import { UserDto } from '@app/shared/models/UserDto';
import { environment } from '@env/environment';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    MatMenuModule,
  ],
})
export class HeaderComponent {
  environment = environment;
  UserRole = UserRole;
  user: UserDto;

  constructor(public authenticationService: AuthenticationService) {
    this.user = this.authenticationService.getUser();
  }

  logout() {
    this.authenticationService.logout();
  }

  showUsersButton() {
    return this.authenticationService.hasPermission('Application.Admin');
  }

  showCompaniesButton() {
    return this.authenticationService.hasPermission('Application.Admin');
  }

  showNewsButton() {
    return this.authenticationService.hasPermission('Application.Admin');
  }

  showReturnProcessButton() {
    return this.authenticationService.hasAnyPermission([
      'Application.Admin',
      'ReturnManager',
      'ReturnUser',
      'CustomsUser',
    ]);
  }

  showDeliveryNotificationButton() {
    return this.authenticationService.hasAnyPermission([
      'Application.Admin',
      'DeliversyNotificationManager',
      'DeliveryNotificationUser',
    ]);
  }
}
